// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"2d4e31b3","787":"b85e5773"}[chunkId] + ".chunk.js";
};